import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-category-add-dialog',
  templateUrl: './category-add-dialog.component.html',
  styleUrls: ['./category-add-dialog.component.scss']
})
export class CategoryAddDialogComponent implements OnChanges {
  @Input() category: any = null;
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  category_name = '';

  constructor(private http: HttpClient) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['category'] && this.category) {
      this.category_name = this.category.category_name;
    } else if (changes['category'] && !this.category) {
      this.category_name = '';
    }
  }

  onSave() {
    if (!this.category_name) return;
    if (this.category && this.category.category_id) {
      // Edit mode
      this.http.put(`https://testapi.ovh/api/strelstvo/categories/${this.category.category_id}`, { category_name: this.category_name })
        .subscribe(
          () => this.save.emit(),
          () => alert('Napaka pri shranjevanju kategorije!')
        );
    } else {
      // Add mode
      this.http.post('https://testapi.ovh/api/strelstvo/categories', { category_name: this.category_name })
        .subscribe(
          () => this.save.emit(),
          () => alert('Napaka pri shranjevanju kategorije!')
        );
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}